import { PublicTokenParamName } from '~/domains/PublicToken';
import { createRoute } from '~/utils/createRoute';

export const route = createRoute({
  loader: () => import('./PaymentPage'),
  path: `payment/:${PublicTokenParamName}`,
});
